import { createPendingRefetchResolver, KPI_ACTIVE_HEARTBEAT_MS } from '@klareospace/pharos-lib-front-utils';
import type { Kpi } from '@klareospace/pharos-lib-types';
import type { Query } from '@tanstack/react-query';

// ─── Resolvers ────────────────────────────────────────────────────────────────

/** Polls while a fetched KPI's `metrics` is still absent (202 placeholder), stops once present. */
export const resolveKpiPendingRefetchInterval = createPendingRefetchResolver<Kpi>(
  (data) => data !== undefined && data.metrics === undefined,
);

/**
 * Extends `resolveKpiPendingRefetchInterval` with a heartbeat: keeps the pending-polling behavior
 * while metrics are absent, then once present polls every `KPI_ACTIVE_HEARTBEAT_MS` while
 * `heartbeat` is true (view actively watched), else stops.
 */
export function resolveKpiActiveRefetchInterval(heartbeat: boolean): (query: Query<Kpi>) => number | false {
  return (query: Query<Kpi>): number | false => {
    const pendingInterval = resolveKpiPendingRefetchInterval(query);
    if (pendingInterval !== false) {
      return pendingInterval;
    }
    return heartbeat ? KPI_ACTIVE_HEARTBEAT_MS : false;
  };
}
